import { Box, Drawer, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useCreateFolderMutation } from 'api/mutations/useCreateFolderMutation';
import { useWindowSize } from 'hooks';

import {
  CancelButton,
  Dialog,
  DuplicateButton,
  FooterActions,
  StyledTextField,
} from '../FolderEditCategoryModal/styled';

// const DESCRIPTION_MAX_LENGTH = 50;

interface CreateFolderModalProps {
  open: boolean;
  onClose: () => void;
  categoryId?: string;
  parentFolderId?: string;
}

export function CreateFolderModal({
  open,
  onClose,
  categoryId,
  parentFolderId,
}: CreateFolderModalProps) {
  const [name, setName] = useState('');
  // const [description, setDescription] = useState('');

  const { createFolderMutation, isLoading } = useCreateFolderMutation();
  const { t } = useTranslation();
  const { isMobile } = useWindowSize();

  useEffect(() => {
    if (open) {
      setName('');
      // setDescription('');
    }
  }, [open]);

  const handleClose = () => {
    setName('');
    // setDescription('');
    onClose();
  };

  const handleCreate = async () => {
    if (!categoryId) return;
    await createFolderMutation({
      name,
      // description: description || undefined,
      category_id: categoryId,
      parent_id: parentFolderId || undefined,
    });
    handleClose();
  };

  // const handleDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   if (e.target.value.length <= DESCRIPTION_MAX_LENGTH) {
  //     setDescription(e.target.value);
  //   }
  // };

  const formContent = (
    <Box sx={{ px: 2, pb: 'env(safe-area-inset-bottom)' }}>
      <Typography variant="h6" fontWeight={700} fontSize="16px" mb={3}>
        {t('resources.documentCategories.folders.createModal.title')}
      </Typography>

      <Box mb={2}>
        <Typography
          variant="body2"
          fontSize="14px"
          fontWeight={500}
          color="text.secondary"
          mb={0.75}
        >
          {t('resources.documentCategories.folders.createModal.folderName')}
        </Typography>
        <StyledTextField
          fullWidth
          placeholder={t(
            'resources.documentCategories.folders.createModal.placeholders.folderName',
          )}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </Box>

      <FooterActions>
        <CancelButton variant="outlined" onClick={handleClose}>
          {t('resources.documentCategories.folders.createModal.buttons.cancel')}
        </CancelButton>
        <DuplicateButton
          variant="contained"
          onClick={handleCreate}
          disabled={!name.trim() || isLoading}
        >
          {t('resources.documentCategories.folders.createModal.buttons.create')}
        </DuplicateButton>
      </FooterActions>
    </Box>
  );

  return isMobile ? (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          borderRadius: '20px 20px 0 0',
          pb: 'env(safe-area-inset-bottom)',
          paddingBottom: '16px',
        },
      }}
    >
      <Box
        sx={{
          width: 36,
          height: 4,
          borderRadius: '2px',
          mx: 'auto',
          my: '12px',
        }}
      />
      {formContent}
    </Drawer>
  ) : (
    <Dialog open={open} onClose={handleClose}>
      {formContent}
    </Dialog>
  );
}
